import { createAction } from 'redux-actions';

export const DASHBOARD_COLLECTION_ACTION_TYPES = {
  createCollection: {
    fulfilled: '[Create Collection] Fulfilled',
    failed: '[Create Collection] Failed',
  },
  videoListHeader: {
    shareButton: {
      clicked: '[Video List Header] Share Button Clicked',
    },
  },
} as const;

export const dashboardCollectionActions = {
  createCollection: {
    fulfilled: createAction(
      DASHBOARD_COLLECTION_ACTION_TYPES.createCollection.fulfilled
    ),
    failed: createAction(
      DASHBOARD_COLLECTION_ACTION_TYPES.createCollection.failed
    ),
  },
  videoListHeader: {
    shareButton: {
      clicked: createAction(
        DASHBOARD_COLLECTION_ACTION_TYPES.videoListHeader.shareButton.clicked
      ),
    },
  },
};
